/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileCamera: {
  name: 'file-camera';
  data: string;
} = {
  name: 'file-camera',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a2 2 0 0 0-2 2v10a1 1 0 1 0 2 0V4h6v4a2 2 0 0 0 2 2h4v4a1 1 0 1 0 2 0V9.414c0-.081-.005-.162-.015-.242a1.004 1.004 0 0 0-.41-.99 2.004 2.004 0 0 0-.16-.182L14 2.586a1.986 1.986 0 0 0-.182-.161.999.999 0 0 0-.99-.41A2 2 0 0 0 12.586 2H6Zm8 3.414V8h2.586L14 5.414ZM7 17a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-3Zm6 0H9v3h4v-3Zm5 0a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Z" fill="currentColor"/></svg>`,
};
